/*
 * LEEVJE – COMPLETE THE LOOK / MINI-ME V1.8
 *
 * Fix:
 * - Klicks werden global per Event Delegation abgefangen.
 * - Funktioniert auch nach AJAX-Neuladen des Cart Drawers.
 * - Button erhält explizit pointer-events/z-index.
 * - Cart Drawer wird nach Add-to-Cart direkt neu geladen.
 */

(function () {
  'use strict';

  var VERSION = '2.3.0';
  var ROOT_SELECTOR = '[data-lv-cart-recommendations]';

  if (
    window.LeevjeCompleteLook &&
    window.LeevjeCompleteLook.version === VERSION
  ) {
    return;
  }

  function ensureStyles() {
    var oldV1 = document.getElementById('leevje-complete-look-styles-v1');
    var oldV2 = document.getElementById('leevje-complete-look-styles-v2');

    if (oldV1) {
      oldV1.remove();
    }

    if (oldV2) {
      oldV2.remove();
    }

    if (document.getElementById('leevje-complete-look-styles-v21')) {
      return;
    }

    var style = document.createElement('style');
    style.id = 'leevje-complete-look-styles-v21';

    style.textContent =
      /*
       * WICHTIG:
       * Wir verändern bewusst NICHT overflow-y am Cart Drawer oder an
       * Prestige-Containern. Dadurch bleibt Prestiges eigener vertikaler
       * Scrollmechanismus vollständig erhalten.
       */
      '.lv-cart-recommendations{' +
        'width:100%;' +
        'min-width:0;' +
        'padding:26px 0 28px;' +
        'border-top:1px solid rgba(41,38,33,.10);' +
        'border-bottom:1px solid rgba(41,38,33,.10);' +
        'background:#F5F1EA;' +
      '}' +

      '.lv-cart-recommendations__section{' +
        'min-width:0;' +
      '}' +

      '.lv-cart-recommendations__section + .lv-cart-recommendations__section{' +
        'margin-top:26px;' +
      '}' +

      '.lv-cart-recommendations__head{' +
        'display:grid;' +
        'gap:5px;' +
        'margin:0 20px 14px;' +
      '}' +

      '.lv-cart-recommendations__head span{' +
        'font-size:10px;' +
        'line-height:1.2;' +
        'letter-spacing:.15em;' +
        'text-transform:uppercase;' +
      '}' +

      '.lv-cart-recommendations__head strong{' +
        'font-size:17px;' +
        'line-height:1.25;' +
        'font-weight:400;' +
      '}' +

      /*
       * Nur die Produktschiene scrollt horizontal.
       * touch-action: pan-x pan-y sorgt dafür, dass vertikale Fingerbewegungen
       * weiterhin den Cart Drawer scrollen können.
       */
      '.lv-cart-recommendations__products{' +
        'display:flex;' +
        'align-items:stretch;' +
        'gap:10px;' +
        'width:100%;' +
        'min-width:0;' +
        'padding:0 20px 6px;' +
        'overflow-x:auto;' +
        'overflow-y:visible;' +
        'scroll-snap-type:x proximity;' +
        'scroll-padding-left:20px;' +
        '-webkit-overflow-scrolling:touch;' +
        'touch-action:pan-x pan-y;' +
        'overscroll-behavior-x:contain;' +
        'scrollbar-width:none;' +
      '}' +

      '.lv-cart-recommendations__products::-webkit-scrollbar{' +
        'display:none;' +
      '}' +

      /*
       * 3+ Produkte: ca. 2,35 Karten sichtbar.
       */
      '.lv-cart-rec-card{' +
        'box-sizing:border-box;' +
        'flex:0 0 calc((100% - 20px) / 2.35);' +
        'min-width:0;' +
        'display:flex;' +
        'flex-direction:column;' +
        'scroll-snap-align:start;' +
        'border:1px solid rgba(41,38,33,.10);' +
        'background:#fff;' +
      '}' +

      /*
       * 1 Produkt: bewusst größer, aber nicht mehr riesig.
       */
      '.lv-cart-recommendations__products > .lv-cart-rec-card:only-child{' +
        'flex:0 0 54%;' +
        'max-width:220px;' +
      '}' +

      /*
       * 2 Produkte: beide vollständig nebeneinander.
       */
      '.lv-cart-recommendations__products > .lv-cart-rec-card:first-child:nth-last-child(2),' +
      '.lv-cart-recommendations__products > .lv-cart-rec-card:first-child:nth-last-child(2) ~ .lv-cart-rec-card{' +
        'flex-basis:calc((100% - 10px) / 2);' +
      '}' +

      '.lv-cart-rec-card__image{' +
        'display:block;' +
        'width:100%;' +
        'aspect-ratio:4/4.6;' +
        'overflow:hidden;' +
        'background:#f7f4ef;' +
      '}' +

      '.lv-cart-rec-card__image img{' +
        'display:block;' +
        'width:100%;' +
        'height:100%;' +
        'object-fit:cover;' +
      '}' +

      '.lv-cart-rec-card__body{' +
        'display:flex;' +
        'flex:1;' +
        'flex-direction:column;' +
        'min-width:0;' +
        'padding:9px;' +
      '}' +

      '.lv-cart-rec-card__title{' +
        'display:-webkit-box;' +
        'overflow:hidden;' +
        '-webkit-box-orient:vertical;' +
        '-webkit-line-clamp:2;' +
        'min-height:2.6em;' +
        'font-size:11px;' +
        'line-height:1.3;' +
        'text-decoration:none;' +
      '}' +

      '.lv-cart-rec-card__price{' +
        'margin-top:4px;' +
        'font-size:11px;' +
        'line-height:1.3;' +
      '}' +

      '.lv-cart-rec-card__actions{' +
        'display:grid;' +
        'grid-template-columns:1fr;' +
        'gap:6px;' +
        'margin-top:auto;' +
        'padding-top:9px;' +
      '}' +

      '.lv-cart-rec-card__select{' +
        'display:block;' +
        'box-sizing:border-box;' +
        'width:100%;' +
        'height:34px;' +
        'min-height:34px;' +
        'padding:0 7px;' +
        'border:1px solid rgba(41,38,33,.20);' +
        'background:#fff;' +
        'font-size:10px;' +
        'line-height:1;' +
        'border-radius:0;' +
        'pointer-events:auto!important;' +
      '}' +

      '.lv-cart-rec-card__add{' +
        'display:flex!important;' +
        'align-items:center;' +
        'justify-content:center;' +
        'box-sizing:border-box;' +
        'width:100%;' +
        'height:34px;' +
        'min-height:34px;' +
        'padding:0 6px;' +
        'border:1px solid #292621!important;' +
        'background:#292621!important;' +
        'color:#fff!important;' +
        'font-size:9px;' +
        'line-height:1;' +
        'letter-spacing:.055em;' +
        'white-space:nowrap;' +
        'cursor:pointer!important;' +
        'border-radius:0;' +
        'pointer-events:auto!important;' +
      '}' +

      '.lv-cart-rec-card__add[disabled]{' +
        'opacity:.5;' +
        'cursor:wait!important;' +
      '}' +

      '.lv-cart-rec-card__feedback,' +
      '.lv-cart-rec-card__unavailable{' +
        'margin:6px 0 0;' +
        'font-size:9px;' +
        'line-height:1.3;' +
      '}' +

      '@media screen and (min-width:700px){' +
        '.lv-cart-recommendations__head{' +
          'margin-left:32px;' +
          'margin-right:32px;' +
        '}' +
        '.lv-cart-recommendations__products{' +
          'padding-left:32px;' +
          'padding-right:32px;' +
          'scroll-padding-left:32px;' +
        '}' +
        '.lv-cart-recommendations__products > .lv-cart-rec-card:only-child{' +
          'flex-basis:50%;' +
          'max-width:225px;' +
        '}' +
      '}';

    document.head.appendChild(style);
  }

  function getCartDrawer() {
    return document.querySelector('#cart-drawer, cart-drawer');
  }

  function dispatchCartEvent(name) {
    try {
      document.dispatchEvent(
        new CustomEvent(name, {
          bubbles: true
        })
      );
    } catch (error) {}
  }

  function refreshCartDrawer() {
    var drawer = getCartDrawer();

    if (!drawer) {
      return Promise.reject(new Error('Cart Drawer nicht gefunden.'));
    }

    /*
     * Der Cart Drawer liegt bei Prestige nicht zwingend innerhalb eines
     * .shopify-section-Wrappers. Die Section-ID ist bei dieser Datei stabil:
     * "cart-drawer". Deshalb laden wir die Section direkt über section_id.
     */
    var sectionId = 'cart-drawer';
    var url = new URL(window.location.href);

    url.searchParams.set('section_id', sectionId);

    return fetch(url.toString(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Cart Drawer konnte nicht neu geladen werden.');
        }

        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshDrawer = doc.querySelector('#cart-drawer, cart-drawer');
        var currentDrawer = getCartDrawer();

        if (!freshDrawer || !currentDrawer) {
          throw new Error('Aktualisierter Cart Drawer wurde nicht gefunden.');
        }

        currentDrawer.innerHTML = freshDrawer.innerHTML;

        ensureStyles();

        if (
          window.LeevjeCartLook &&
          typeof window.LeevjeCartLook.init === 'function'
        ) {
          window.LeevjeCartLook.init();
        }

        dispatchCartEvent('cart:updated');
      });
  }

  function setFeedback(card, text) {
    var feedback = card.querySelector('[data-lv-rec-feedback]');
    if (feedback) {
      feedback.textContent = text || '';
    }
  }

  function addProduct(card, button) {
    var variantField = card.querySelector('[data-lv-rec-variant]');

    if (!variantField || !variantField.value) {
      setFeedback(card, 'Bitte zuerst eine Größe wählen.');
      return;
    }

    if (button.getAttribute('data-lv-loading') === 'true') {
      return;
    }

button.setAttribute('data-lv-loading', 'true');
button.disabled = true;
setFeedback(card, '');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantField.value),
            quantity: 1
          }
        ]
      })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json()
            .catch(function () {
              return {};
            })
            .then(function (payload) {
              throw new Error(
                payload.description ||
                payload.message ||
                'Produkt konnte nicht hinzugefügt werden.'
              );
            });
        }

        return response.json();
      })
      .then(function () {
        setFeedback(card, 'Hinzugefügt. Warenkorb wird aktualisiert …');
        return refreshCartDrawer();
      })
      .then(function () {
        dispatchCartEvent('cart:change');
        dispatchCartEvent('cart:update');
        dispatchCartEvent('cart:refresh');
      })
      .catch(function (error) {
        console.error('[LEEVJE Complete Look]', error);

        button.removeAttribute('data-lv-loading');
        button.disabled = false;
        button.textContent = 'HINZUFÜGEN';

        setFeedback(
          card,
          error && error.message
            ? error.message
            : 'Das hat leider nicht geklappt.'
        );
      });
  }


  function removeCartLine(removeLink) {
    var drawer = getCartDrawer();
    var lineKey = removeLink.getAttribute('data-line-key');

    if (!drawer || !drawer.contains(removeLink) || !lineKey) {
      return;
    }

    if (removeLink.getAttribute('data-lv-removing') === 'true') {
      return;
    }

    removeLink.setAttribute('data-lv-removing', 'true');
    removeLink.setAttribute('aria-disabled', 'true');

    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: 0
      })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Artikel konnte nicht entfernt werden.');
        }
        return response.json();
      })
      .then(function () {
        return refreshCartDrawer();
      })
      .then(function () {
        dispatchCartEvent('cart:change');
        dispatchCartEvent('cart:update');
      })
      .catch(function (error) {
        console.error('[LEEVJE Cart Remove]', error);
        removeLink.removeAttribute('data-lv-removing');
        removeLink.removeAttribute('aria-disabled');
      });
  }

  function handleRemoveClick(event) {
    var target = event.target;

    if (!target || !target.closest) {
      return;
    }

    var removeLink = target.closest('[data-lv-cart-remove]');

    if (!removeLink) {
      return;
    }

    var drawer = getCartDrawer();

    if (!drawer || !drawer.contains(removeLink)) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    removeCartLine(removeLink);
  }

  function handleGlobalClick(event) {
    var target = event.target;

    if (!target || !target.closest) {
      return;
    }

    var button = target.closest('[data-lv-rec-add]');

    if (!button) {
      return;
    }

    var root = button.closest(ROOT_SELECTOR);

    if (!root) {
      return;
    }

    var card = button.closest('[data-lv-rec-card]');

    if (!card) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    addProduct(card, button);
  }

  function handleVariantChange(event) {
    var target = event.target;

    if (
      !target ||
      !target.matches ||
      !target.matches('[data-lv-rec-variant]')
    ) {
      return;
    }

    var card = target.closest('[data-lv-rec-card]');

    if (card && target.value) {
      setFeedback(card, '');
    }
  }

  function init() {
    ensureStyles();
  }

  /*
   * Capture=true:
   * Der Klick wird schon in der Capture-Phase abgefangen.
   * Damit kann Prestige oder ein anderes Theme-Script ihn nicht vorher blockieren.
   */
  document.addEventListener('click', handleRemoveClick, true);
  document.addEventListener('click', handleGlobalClick, true);
  document.addEventListener('change', handleVariantChange, true);

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  window.LeevjeCompleteLook = {
    version: VERSION,
    init: init,
    refreshCartDrawer: refreshCartDrawer
  };

  init();
})();
